import React from 'react';
import Icon from '../../../components/AppIcon';

const ComparisonMatrix = () => {
  const services = [
    {
      name: "HR Solutions",
      features: {
        recruitment: true,
        training: true,
        compliance: true,
        payroll: true,
        consulting: true,
        support: "24/7"
      }
    },
    {
      name: "Global Trade",
      features: {
        recruitment: false,
        training: true,
        compliance: true,
        payroll: false,
        consulting: true,
        support: "Business Hours"
      }
    },
    {
      name: "Engineering",
      features: {
        recruitment: true,
        training: true,
        compliance: true,
        payroll: false,
        consulting: true,
        support: "24/7"
      }
    }
  ];

  const featureLabels = {
    recruitment: "Talent Acquisition",
    training: "Training Programs",
    compliance: "Compliance Management",
    payroll: "Payroll Services",
    consulting: "Strategic Consulting",
    support: "Support Availability"
  };

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-muted/30">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3 md:mb-4">
            Service Comparison Matrix
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-muted-foreground max-w-3xl mx-auto">
            Compare our comprehensive service offerings to find the perfect fit for your business needs
          </p>
        </div>

        <div className="bg-card rounded-xl shadow-lg overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full min-w-max">
              <thead>
                <tr className="bg-primary text-white">
                  <th className="px-4 md:px-6 py-3 md:py-4 text-left text-sm md:text-base font-semibold">
                    Features
                  </th>
                  {services?.map((service) => (
                    <th
                      key={service?.name}
                      className="px-4 md:px-6 py-3 md:py-4 text-center text-sm md:text-base font-semibold whitespace-nowrap"
                    >
                      {service?.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {Object.entries(featureLabels)?.map(([key, label], index) => (
                  <tr
                    key={key}
                    className={index % 2 === 0 ? 'bg-background' : 'bg-muted/50'}
                  >
                    <td className="px-4 md:px-6 py-3 md:py-4 text-sm md:text-base text-foreground font-medium">
                      {label}
                    </td>
                    {services?.map((service) => (
                      <td
                        key={`${service?.name}-${key}`}
                        className="px-4 md:px-6 py-3 md:py-4 text-center"
                      >
                        {typeof service?.features?.[key] === 'boolean' ? (
                          service?.features?.[key] ? (
                            <Icon
                              name="CheckCircle2"
                              size={20}
                              className="inline text-success"
                            />
                          ) : (
                            <Icon
                              name="XCircle"
                              size={20}
                              className="inline text-muted-foreground"
                            />
                          )
                        ) : (
                          <span className="text-xs md:text-sm font-semibold text-foreground whitespace-nowrap">
                            {service?.features?.[key]}
                          </span>
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="p-4 md:p-6 bg-muted/30 border-t border-border">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">
              <p className="text-xs md:text-sm text-muted-foreground text-center md:text-left">
                All services include dedicated account management and customizable solutions
              </p>
              <button className="px-6 py-2 md:py-3 bg-primary hover:bg-primary/90 text-white rounded-lg font-semibold transition-all duration-200 flex items-center gap-2 text-sm md:text-base whitespace-nowrap">
                <Icon name="MessageSquare" size={20} />
                Discuss Requirements
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComparisonMatrix;